import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { getOrganisationPredictUrl, joinRouteMatchUrl, ROUTES } from '@futrli/shared-services';

import { ChartOfAccountsContainerRouter } from '../../chart-of-accounts/chart-of-accounts-container-router';
import { DashboardsRoutingContainer } from '../../dashboards/containers/dashboards-routing-container';
import { ForecastingContainer } from '../../forecast/containers/forecasting-container';
import { NavItem } from '../components/navbar/types';
import { NonFinancialDrivers } from '../../non-financial-drivers/non-financial-drivers';
import { OrganisationOverviewDashboard } from '../../dashboard/organisation-overview-dashboard';
import { ReportingContainer } from '../../report-builder/containers/reporting-container';

export const useOrganisationManagementRoutes = () => {
  const intl = useIntl();
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';

  const output = useMemo(() => {
    const routes: NavItem[] = [
      {
        name: intl.formatMessage({ id: 'predict.overview', defaultMessage: 'Overview' }),
        route: ROUTES.HOME,
        component: OrganisationOverviewDashboard,
        url: joinRouteMatchUrl('', getOrganisationPredictUrl(workspaceId, organisationId), ROUTES.HOME)
      },
      {
        name: intl.formatMessage({ id: 'predict.dashboards', defaultMessage: 'Dashboards' }),
        route: `${ROUTES.DASHBOARDS}/*`,
        component: DashboardsRoutingContainer,
        hidden: true,
        url: joinRouteMatchUrl('', getOrganisationPredictUrl(workspaceId, organisationId), ROUTES.DASHBOARDS)
      },
      {
        name: intl.formatMessage({ id: 'predict.forecasting', defaultMessage: 'Forecasting' }),
        route: `${ROUTES.FORECASTS}/*`,
        component: ForecastingContainer,
        url: joinRouteMatchUrl('', getOrganisationPredictUrl(workspaceId, organisationId), ROUTES.FORECASTS)
      },
      {
        name: intl.formatMessage({ id: 'predict.reporting', defaultMessage: 'Reporting' }),
        route: `${ROUTES.REPORTING}/*`,
        component: ReportingContainer,
        url: joinRouteMatchUrl('', getOrganisationPredictUrl(workspaceId, organisationId), ROUTES.REPORTING)
      },
      {
        name: intl.formatMessage({ id: 'predict.chart_of_accounts', defaultMessage: 'Chart of accounts' }),
        route: `${ROUTES.CHART_OF_ACCOUNTS}/*`,
        component: ChartOfAccountsContainerRouter,
        url: joinRouteMatchUrl('', getOrganisationPredictUrl(workspaceId, organisationId), ROUTES.CHART_OF_ACCOUNTS)
      },
      {
        name: intl.formatMessage({ id: 'reporting.grouping.drivers', defaultMessage: 'Drivers' }),
        route: `${ROUTES.NON_FINANCIAL_DRIVERS}/*`,
        component: NonFinancialDrivers,
        url: joinRouteMatchUrl('', getOrganisationPredictUrl(workspaceId, organisationId), ROUTES.NON_FINANCIAL_DRIVERS)
      }
    ];

    return {
      routes,
      redirect: {
        to: ROUTES.HOME
      }
    };
  }, [intl, workspaceId, organisationId]);

  return output;
};
